export default __webpack_public_path__ + "src/assets/icn-smart-contract.7d39659cd9f052fc6895d852fea782ef.svg";